"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@material-ui/core");
var _queryString = _interopRequireDefault(require("query-string"));
var _MobileDefaultBar = _interopRequireDefault(require("./MobileDefaultBar"));
var _MobileSearchBar = _interopRequireDefault(require("./MobileSearchBar"));
var _headerContext = require("./headerContext");
var _mobileStyles = _interopRequireDefault(require("./mobileStyles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function getUrlQuery() {
  if (window.location.search && window.location.search.includes('query=')) {
    const searchTerm = _queryString.default.parse(window.location.search).query;
    return searchTerm;
  }
  return null;
}
class MobileTopContent extends _react.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "setBarFromHistory", (evt, state, actions) => {
      evt.preventDefault();
      evt.stopPropagation();
      const searchTerm = getUrlQuery();
      return state.fromHome ? actions.clickLogo() : actions.submitSearch(searchTerm);
    });
    _defineProperty(this, "renderTopBar", (state, actions) => {
      if (state.initial) {
        return this.defaultBar();
      }
      if (state.final) {
        return this.showResultsBar();
      }
      return this.modalSearchBar(state, actions);
    });
    _defineProperty(this, "defaultBar", () => {
      const {
        username,
        email,
        onClickHome,
        menuItems,
        hiddenMenu,
        logo,
        logoImg,
        navigateMenu,
        drawerItems,
        isFullHeight
      } = this.props;
      return /*#__PURE__*/_react.default.createElement(_MobileDefaultBar.default, {
        username: username,
        email: email,
        onClickHome: onClickHome,
        menuItems: menuItems,
        hiddenMenu: hiddenMenu,
        logo: logo,
        logoImg: logoImg,
        navigateMenu: navigateMenu,
        drawerItems: drawerItems,
        isFullHeight: isFullHeight
      });
    });
    _defineProperty(this, "showResultsBar", () => {
      const {
        searchCallback,
        searchPlaceHolder
      } = this.props;
      return /*#__PURE__*/_react.default.createElement(_MobileSearchBar.default, {
        searchCallback: searchCallback,
        searchPlaceHolder: searchPlaceHolder
      });
    });
    _defineProperty(this, "modalSearchBar", (state, actions) => {
      const {
        searchCallback,
        searchPlaceHolder
      } = this.props;
      const classes = (0, _mobileStyles.default)();
      return /*#__PURE__*/_react.default.createElement(_core.Modal, {
        open: state.searching,
        onClose: state.fromHome ? actions.clickLogo : actions.backToSearchResult,
        id: "sui-search-modal",
        "aria-labelledby": "sui-search-modal",
        "aria-describedby": "sui-search-modal-mobile",
        className: classes.backdrop
      }, /*#__PURE__*/_react.default.createElement(_MobileSearchBar.default, {
        searchCallback: searchCallback,
        searchPlaceHolder: searchPlaceHolder
      }));
    });
  }
  render() {
    return /*#__PURE__*/_react.default.createElement(_headerContext.HeaderContext.Consumer, null, _ref => {
      let {
        state,
        actions
      } = _ref;
      window.onpopstate = evt => this.setBarFromHistory(evt, state, actions);
      const searchTerm = getUrlQuery();
      if (state.initial && searchTerm !== null) {
        actions.submitSearch(searchTerm);
        return null;
      }
      return this.renderTopBar(state, actions);
    });
  }
}
MobileTopContent.propTypes = {
  username: _propTypes.default.string.isRequired,
  email: _propTypes.default.string.isRequired,
  onClickHome: _propTypes.default.func.isRequired,
  searchCallback: _propTypes.default.func.isRequired,
  searchPlaceHolder: _propTypes.default.string.isRequired,
  menuItems: _propTypes.default.arrayOf(_propTypes.default.shape({
    nodeIcon: _propTypes.default.node,
    label: _propTypes.default.string,
    onClick: _propTypes.default.func
  })).isRequired,
  drawerItems: _propTypes.default.arrayOf(_propTypes.default.shape({
    nodeIcon: _propTypes.default.node,
    label: _propTypes.default.string,
    onClick: _propTypes.default.func
  }).isRequired),
  hiddenMenu: _propTypes.default.bool,
  logo: _propTypes.default.element,
  navigateMenu: _propTypes.default.bool,
  logoImg: _propTypes.default.node,
  isFullHeight: _propTypes.default.bool
};
MobileTopContent.defaultProps = {
  hiddenMenu: false,
  navigateMenu: false,
  drawerItems: null,
  logo: null,
  logoImg: null,
  isFullHeight: false
};
var _default = exports.default = MobileTopContent;